import React, { useCallback } from 'react'

function sendUDP(payload) {
    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.controllerHandler) {
        window.webkit.messageHandlers.controllerHandler.postMessage(
            JSON.stringify({ event: 'UDP', command: JSON.stringify(payload) })
        )
    }
}

const SEC_KEYS = [
    { label: '↑', key: 'ArrowUp' },
    { label: '↓', key: 'ArrowDown' },
    { label: 'Space', key: 'Space' },
    { label: 'PgUp', key: 'PageUp' },
    { label: 'PgDn', key: 'PageDown' },
    { label: 'Esc', key: 'Escape' },
    { label: 'Enter', key: 'Enter' },
]

export default function ControllerModalBrowserSlideshow({ onClose }) {
    const onKey = useCallback((key) => {
        sendUDP({ type: 'keystroke-special', key })
    }, [])

    return (
        <div style={styles.container}>
            <div style={styles.header}>
                <span style={styles.headerTitle}>Slideshow Control</span>
                <button style={styles.closeBtn} onClick={onClose}>✕</button>
            </div>

            <div style={styles.navRow}>
                <button style={styles.navBtn} onClick={() => onKey('ArrowLeft')}>←</button>
                <button style={styles.navBtn} onClick={() => onKey('ArrowRight')}>→</button>
            </div>

            <div style={styles.secRow}>
                {SEC_KEYS.map(k => (
                    <button key={k.key} style={styles.secBtn} onClick={() => onKey(k.key)}>
                        {k.label}
                    </button>
                ))}
            </div>

            <div style={styles.presentRow}>
                <button style={styles.presentBtn} onClick={() => onKey('Alt+Shift+F5')}>
                    ▶ Present
                </button>
            </div>
        </div>
    )
}

const styles = {
    container: {
        position: 'fixed', inset: 0, zIndex: 9000,
        background: 'rgba(20,20,28,0.97)',
        display: 'flex', flexDirection: 'column',
        color: '#fff', fontFamily: 'sans-serif',
        userSelect: 'none',
    },
    header: {
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '14px 20px 10px',
        borderBottom: '1px solid rgba(255,255,255,0.1)',
        flexShrink: 0,
    },
    headerTitle: { fontSize: 16, fontWeight: 600, letterSpacing: 0.3 },
    closeBtn: {
        background: 'none', border: 'none', color: '#fff',
        fontSize: 20, cursor: 'pointer', padding: '4px 8px',
    },
    navRow: {
        flex: 1,
        display: 'flex', gap: 20, padding: '40px 30px',
        alignItems: 'stretch',
    },
    navBtn: {
        flex: 1,
        fontSize: 64, fontWeight: 300,
        borderRadius: 16,
        border: '1px solid rgba(255,255,255,0.2)',
        background: 'rgba(255,255,255,0.1)',
        color: '#fff', cursor: 'pointer',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
    },
    secRow: {
        display: 'flex', gap: 6, padding: '0 20px 16px', flexWrap: 'wrap', flexShrink: 0,
    },
    secBtn: {
        flex: 1, minWidth: 52,
        padding: '13px 4px',
        borderRadius: 8,
        border: '1px solid rgba(255,255,255,0.15)',
        background: 'rgba(255,255,255,0.1)',
        color: '#fff', fontSize: 14, cursor: 'pointer',
    },
    presentRow: {
        padding: '0 20px 30px', flexShrink: 0,
    },
    presentBtn: {
        width: '100%',
        padding: '16px',
        borderRadius: 10,
        border: '1px solid rgba(100,200,100,0.4)',
        background: 'rgba(60,140,60,0.3)',
        color: '#8fda8f', fontSize: 16, fontWeight: 600, cursor: 'pointer',
        letterSpacing: 0.5,
    },
}
